import React, { useState, useEffect, useRef } from 'react';
import { getRequestParams, formatDate } from '../../helpers/globalfunctions.js';
import { SelectBox } from 'devextreme-react/select-box';
import { StatusType, TripStatus, LogType } from '../../helpers/fixcodes';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import NumberFormat from 'react-number-format';
import { ViewReservationComponent } from '../Shared/ViewReservationComponent';
import { ReservationHistoryComponent } from '../Shared/ReservationHistoryComponent';
import { VoidReservationComponent } from '../Shared/VoidReservationComponent';
import { CompleteReservationComponent } from '../Shared/CompleteReservationComponent';
import { NoShowReservationComponent } from '../Shared/NoShowReservationComponent';
import { SplitReservationComponent } from '../Shared/SplitReservationComponent';
import { VehicleHistoryComponent } from '../Shared/VehicleHistoryComponent';
import { LocateVehicleComponent } from '../Shared/LocateVehicleComponent';
import { DocumentsComponent } from '../Shared/DocumentsComponent';
import { ReservationActualTimeComponent } from '../Shared/ReservationActualTimeComponent';
import { MeetAndGreeterComponent } from '../Shared/MeetAndGreeterComponent';
import { RideTrackingReplay } from '../Shared/RideTrackingReplay';
import { ReservationDateTimeComponent } from '../Shared/ReservationDateTimeComponent';
import { ViewUpdateFlightStatusComponent } from '../Shared/ViewUpdateFlightStatusComponent';
import { SendAirlineCrewMessageComponent } from '../Shared/SendAirlineCrewMessageComponent';
import { AddPassengerComponent } from '../Shared/AddPassengerComponent';

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes â€” matches DispatchComponent cache TTL

function readCache(key) {
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const { data, ts } = JSON.parse(raw);
        if (Date.now() - ts > CACHE_TTL_MS) { sessionStorage.removeItem(key); return null; }
        return data;
    } catch { return null; }
}

function writeCache(key, data) {
    try { sessionStorage.setItem(key, JSON.stringify({ data, ts: Date.now() })); } catch { }
}

// [Item 8] Removed dead session constants only used in commented-out allowEdit logic
const allowToAddDriverWorkingHours = sessionStorage.getItem("session_allowToAddDriverWorkingHours");
const session_isShuttleDispatchLite = sessionStorage.getItem("session_isShuttleDispatchLite") === "true";
const currentTime = sessionStorage.getItem("session_locationTime") === ""
    ? new Date()
    : new Date(sessionStorage.getItem("session_locationTime"));

const driverWorkingHoursobject = [
    { id: 1, name: "1" }, { id: 2, name: "2" }, { id: 3, name: "3" },
    { id: 4, name: "4" }, { id: 5, name: "5" }, { id: 6, name: "6" },
    { id: 7, name: "7" }, { id: 8, name: "8" }, { id: 9, name: "9" },
    { id: 10, name: "10" }, { id: 11, name: "11" }, { id: 12, name: "12" },
];

// [Item 10] Converted from class component to functional component
// [Item 9]  Props used directly â€” no longer copied into state
export function DispatchDetailComponent({
    isDispatchRowIndex,
    dispatchRideId,
    singleRideSource,
    refreshDataSource,
    updateSingleRow,
    stopAutoRefresh,
    stopAutoRefreshHandle,
    handleRefresh,
    editViewRide,
    serviceVehicles = [],
    serviceDrivers = [],
    serviceStatusList = [],
}) {
    // Prefer targeted single-row update; fall back to full refresh if unavailable
    const refreshRow = updateSingleRow
        ? () => updateSingleRow(dispatchRideId)
        : refreshDataSource;
    // [Item 7] mountedRef replaces _isMounted class property â€” same pattern, hooks style
    const mountedRef = useRef(true);

    // â”€â”€â”€ Modal refs â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const viewReservationModal = useRef(null);
    const reservationHistoryModal = useRef(null);
    const addPassengerModal = useRef(null);
    const meetAndGreeterDataModel = useRef(null);
    const reservationDocumentsModal = useRef(null);
    const rideTrackingReplay = useRef(null);
    const voidReservationModal = useRef(null);
    const noShowReservationModal = useRef(null);
    const completeReservationModal = useRef(null);
    const splitReservationModal = useRef(null);
    const vehicleHistoryModal = useRef(null);
    const locateVehicleModal = useRef(null);
    const actualTimeModal = useRef(null);
    const changeDateTimeReservationModal = useRef(null);
    const viewUpdateFlightStatusComponent = useRef(null);
    const SendAirlineCrewMessageComponentModel = useRef(null);

    // â”€â”€â”€ State â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    // User-editable form values
    const [formValues, setFormValues] = useState({
        dispatchVehicleId: 0,
        dispatchVehicleNo: "",
        dispatchDriverId: 0,
        dispatchStatusId: 0,
        dispatchSearchDate: formatDate(currentTime, "MM/dd/yyyy hh:mm"),
        driverWorkingHoursId: 0,
        driverWorkingHoursValue: "0",
        driverMobileNumber: '',
    });

    // UI visibility / enable-disable flags â€” computed from trip status in initRideState
    const [displayFlags, setDisplayFlags] = useState({
        isSubmited: false,
        isCloseDispatchDisplay: false,
        isManualDispatchDisplay: false,
        isTripStatusDisplay: false,
        isNoshowDisplay: false,
        iMeetGreetDisplay: 0,
        isSaveCompleteDisplay: false,
        isRideCompleteDisplay: false,
        isSaveDisabled: true,
        isSaveAssignDisabled: true,
        isSaveUnAssignDisabled: true,
        isVehicleUnAssignDisabled: true,
        isDriverUnAssignDisabled: true,
        isDocumentsAttachment: true,
        isVoidShow: false,
        isRecallShow: false,
        isUnAssigned: false,
        isPreUnAssigned: false,
        isSplitRideDisplay: false,
        isActualTime: false,
        isUndoSplitRideDisplay: false,
        isShowVehicleHistory: false,
        isShowFlightStatus: false,
    });

    // API in-flight / spinner states
    const [loading, setLoading] = useState({
        isStatusSubmited: false,
        isHistorySubmited: false,
        isVehicleAssignedSubmited: false,
        isVehicleUnAssignedSubmited: false,
        isSaveCompleteSubmited: false,
        isRecallSubmited: false,
    });

    // Fetched dropdown data â€” seeded from parent props to avoid re-fetching
    const [serviceData, setServiceData] = useState({
        serviceVehicles: serviceVehicles,
        serviceStatusList: serviceStatusList,
        serviceDrivers: serviceDrivers,
    });

    // Validation errors
    const [errors, setErrors] = useState({
        dispatchVehicleId: "",
        dispatchVehicleNo: "",
        dispatchDriverId: "",
        dispatchVehicleIdTypeId: 0,
        driverMobileNumber: "",
    });

    // â”€â”€â”€ Lifecycle â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    useEffect(() => {
        mountedRef.current = true;

        const getStatusList = async () => {
            if (serviceStatusList.length > 0) return; // provided by parent
            const cached = readCache('session_tripstatus');
            if (cached && cached.statusType) { setServiceData(prev => ({ ...prev, serviceStatusList: cached.statusType })); return; }
            try {
                const requestParams = getRequestParams('GET', {});
                const response = await fetch('/status-api/' + StatusType.Booking, requestParams);
                const data = await response.json();
                if (mountedRef.current) {
                    writeCache('session_tripstatus', data);
                    setServiceData(prev => ({ ...prev, serviceStatusList: data.statusType }));
                }
            } catch { /* silent */ }
        };

        const getServiceVehicles = async () => {
            if (serviceVehicles.length > 0) return; // provided by parent
            const cached = readCache('session_vehicles');
            if (cached && cached.vehiclesDropdown) { setServiceData(prev => ({ ...prev, serviceVehicles: cached.vehiclesDropdown })); return; }
            try {
                const requestParams = getRequestParams('GET', {});
                const response = await fetch('/vehicle-api/dropdown-customer-vehicles/0/0', requestParams);
                const data = await response.json();
                if (mountedRef.current) {
                    writeCache('session_vehicles', data);
                    setServiceData(prev => ({ ...prev, serviceVehicles: data.vehiclesDropdown }));
                }
            } catch { /* silent */ }
        };

        const getDrivers = async () => {
            if (serviceDrivers.length > 0) return; // provided by parent
            const cached = readCache('session_drivers');
            if (cached && cached.driversDropdownList) { setServiceData(prev => ({ ...prev, serviceDrivers: cached.driversDropdownList })); return; }
            try {
                const requestParams = getRequestParams('GET', {});
                const response = await fetch('/driver-api/dropdown/', requestParams);
                const data = await response.json();
                if (mountedRef.current) {
                    writeCache('session_drivers', data);
                    setServiceData(prev => ({ ...prev, serviceDrivers: data.driversDropdownList }));
                }
            } catch { /* silent */ }
        };

        Promise.all([getStatusList(), getServiceVehicles(), getDrivers()]);
        initRideState();

        return () => { mountedRef.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // â”€â”€â”€ Ride state initialisation â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    // [Item 1] Single batch update replacing ~20 separate setState calls
    // [Item 9] Reads directly from singleRideSource prop â€” not from state copy
    const initRideState = () => {
        const data = singleRideSource;
        if (data == null) return;

        const statusId = data.tripStatusId;

        const formUpdate = {
            dispatchSearchDate: formatDate(new Date(data.pickupDateTime), "MM/dd/yyyy hh:mm"),
            dispatchStatusId: statusId,
            dispatchDriverId: data.driverId,
            dispatchVehicleId: data.vehicleId,
            dispatchVehicleNo: data.vehicleNo,
            driverMobileNumber: data.driverMobileNo,
        };

        const flagUpdate = {
            isShowVehicleHistory: Number(data.vehicleId) > 0,
            isSaveDisabled: true,
            isSaveAssignDisabled: true,
            isVehicleUnAssignDisabled: true,
            isDriverUnAssignDisabled: true,
            isVoidShow: false,
            isShowFlightStatus: false,
            isSplitRideDisplay: false,
            isUndoSplitRideDisplay: false,
            isUnAssigned: false,
            isPreUnAssigned: false,
            iMeetGreetDisplay: 0,
            isSaveCompleteDisplay: false,
            isRecallShow: false,
            isActualTime: false,
            isDocumentsAttachment: true,
            isTripStatusDisplay: false,
            isRideCompleteDisplay: false,
            isNoshowDisplay: true,
        };

        // Block 1: button enable/disable state
        switch (statusId) {
            case parseInt(TripStatus.PENDING):
            case parseInt(TripStatus.VEHICLEUNASSIGNED):
            case parseInt(TripStatus.DRIVERREJECTED):
                flagUpdate.isSaveDisabled = false;
                flagUpdate.isSaveAssignDisabled = false;
                flagUpdate.isVoidShow = true;
                flagUpdate.isVehicleUnAssignDisabled = false;
                flagUpdate.isDriverUnAssignDisabled = false;
                flagUpdate.isShowFlightStatus = true;
                if (parseInt(data.parentRideId) === 0 && parseInt(data.noOfAdults) > 1) {
                    flagUpdate.isSplitRideDisplay = true;
                }
                if (parseInt(data.parentRideId) > 0 && parseInt(data.parentRideId) === parseInt(data.rideId)) {
                    flagUpdate.isUndoSplitRideDisplay = true;
                }
                break;
            default:
                break;
        }

        // Block 2: assign/unassign/meetGreet/saveComplete/recall visibility
        switch (statusId) {
            case parseInt(TripStatus.PENDING):
            case parseInt(TripStatus.VEHICLEUNASSIGNED):
            case parseInt(TripStatus.DRIVERREJECTED):
                if (data.isPreAssignedRide) {
                    flagUpdate.isUnAssigned = data.vehicleId > 0 || data.driverId > 0;
                    flagUpdate.isPreUnAssigned = true;
                } else {
                    flagUpdate.isPreUnAssigned = false;
                }
                flagUpdate.isVoidShow = true;
                flagUpdate.iMeetGreetDisplay = data.meetGreetName === "" ? 1 : 2;
                flagUpdate.isSaveCompleteDisplay = true;
                break;
            case parseInt(TripStatus.VEHICLEASSIGNED):
            case parseInt(TripStatus.DRIVERACCEPTED):
            case parseInt(TripStatus.ONLOCATION):
                flagUpdate.isUnAssigned = true;
                flagUpdate.isPreUnAssigned = false;
                flagUpdate.iMeetGreetDisplay = data.meetGreetName === "" ? 1 : 2;
                break;
            case parseInt(TripStatus.COMPLETED):
            case parseInt(TripStatus.NOSHOW):
                flagUpdate.isRecallShow = false;
                flagUpdate.iMeetGreetDisplay = 0;
                flagUpdate.isActualTime = true;
                break;
            case parseInt(TripStatus.CANCELLED):
            case parseInt(TripStatus.AUTOCANCELLED):
                flagUpdate.isRecallShow = true;
                flagUpdate.iMeetGreetDisplay = 0;
                flagUpdate.isDocumentsAttachment = false;
                break;
            default:
                flagUpdate.isUnAssigned = false;
                flagUpdate.isPreUnAssigned = false;
                flagUpdate.iMeetGreetDisplay = 0;
                flagUpdate.isDocumentsAttachment = false;
                flagUpdate.isVoidShow = true;
                flagUpdate.isRecallShow = false;
                break;
        }

        // Block 3: trip status in-progress display
        switch (statusId) {
            case parseInt(TripStatus.DRIVERACCEPTED):
            case parseInt(TripStatus.VEHICLEASSIGNED):
            case parseInt(TripStatus.ONLOCATION):
            case parseInt(TripStatus.PAXLOAD):
            case parseInt(TripStatus.PAXUNLOAD):
                flagUpdate.isTripStatusDisplay = true;
                flagUpdate.isRideCompleteDisplay = true;
                break;
            default:
                break;
        }

        // Block 4: no-show visibility
        switch (statusId) {
            case parseInt(TripStatus.CANCELLED):
            case parseInt(TripStatus.AUTOCANCELLED):
            case parseInt(TripStatus.COMPLETED):
            case parseInt(TripStatus.NOSHOW):
            case parseInt(TripStatus.NOSHOWNONBILLABLE):
                flagUpdate.isNoshowDisplay = false;
                break;
            default:
                break;
        }

        if (mountedRef.current) {
            setFormValues(prev => ({ ...prev, ...formUpdate }));
            setDisplayFlags(prev => ({ ...prev, ...flagUpdate }));
        }
    };

    // â”€â”€â”€ Validation â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleJobAssignValidation = () => {
        const errs = { ...errors, dispatchVehicleId: "", dispatchDriverId: "" };
        let formIsValid = true;
        if (formValues.dispatchVehicleId === 0 && formValues.dispatchDriverId === 0) {
            formIsValid = false;
            errs.dispatchVehicleId = "Please select vehicle or driver.";
        }
        setErrors(errs);
        return formIsValid;
    };

    // â”€â”€â”€ Input handlers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleInputChange = (event) => {
        const { name, type, value, checked } = event.target;
        setFormValues(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value  }));
    };

    const vehicleItemRender = (item) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
            <i className="fas fa-car" style={{ color: '#1a73e8', fontSize: '0.78rem', flexShrink: 0 }}></i>
            <span>{item.name}</span>
        </div>
    );

    const vehicleFieldRender = (data) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '7px', paddingLeft: '8px', height: '100%' }}>
            <i className="fas fa-car" style={{ color: data ? '#1a73e8' : '#adb5bd', fontSize: '0.78rem', flexShrink: 0 }}></i>
            <input
                className="dx-texteditor-input"
                defaultValue={data ? data.name : ''}
                placeholder="Select vehicle"
                style={{ border: 'none', background: 'transparent', flex: 1, padding: 0, color: '#000' }}
            />
        </div>
    );

    const driverItemRender = (item) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
            <i className="fas fa-user" style={{ color: '#16a34a', fontSize: '0.78rem', flexShrink: 0 }}></i>
            <span>{item.name}</span>
        </div>
    );

    const driverFieldRender = (data) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '7px', paddingLeft: '8px', height: '100%' }}>
            <i className="fas fa-user" style={{ color: data ? '#16a34a' : '#adb5bd', fontSize: '0.78rem', flexShrink: 0 }}></i>
            <input
                className="dx-texteditor-input"
                defaultValue={data ? data.name : ''}
                placeholder="Select driver"
                style={{ border: 'none', background: 'transparent', flex: 1, padding: 0, color: '#000' }}
            />
        </div>
    );

    const handleDispatchVehicleChange = (selectedOption) => {
        setFormValues(prev => ({
            ...prev,
            dispatchVehicleId: selectedOption.selectedItem?.id ?? 0,
            dispatchVehicleNo: selectedOption.selectedItem?.name ?? "",
        }));
    };

    const handleDispatchDriverChange = (selectedOption) => {
        setFormValues(prev => ({ ...prev, dispatchDriverId: selectedOption.selectedItem?.id ?? 0 }));
    };

    const handleDispatchStatusChange = (selectedOption) => {
        setFormValues(prev => ({ ...prev, dispatchStatusId: selectedOption.selectedItem?.id ?? 0 }));
    };

    // [Item 8] Removed unused `var dt = formatDate(...)` dead variable
    const handleDispatchSearchDateChange = (date) => {
        setFormValues(prev => ({ ...prev, dispatchSearchDate: date }));
    };

    const handleDriverWorkingHourChange = (selectedOption) => {
        setFormValues(prev => ({
            ...prev,
            driverWorkingHoursId: selectedOption.selectedItem?.id ?? 0,
            driverWorkingHoursValue: selectedOption.selectedItem?.name ?? "0",
        }));
    };

    // â”€â”€â”€ Modal handlers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleViewReservationModal = (e, data) => {
        e.preventDefault();
        viewReservationModal.current.showModal("View Reservation", data);
    };

    const handleReservationHistoryModal = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        reservationHistoryModal.current.showModal("Reservation History", data.rideId);
    };

    const handlePassengersModal = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        addPassengerModal.current.showModal("Add Passenger", data.rideId);
    };

    const handleMeetAndGreeterNameModal = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        meetAndGreeterDataModel.current.showModal("Set Meet & Greeter Name", data.rideId);
    };

    const handleRideDocumentsModal = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        const rideArray = [data.rideId];
        reservationDocumentsModal.current.showModal('Ride Id', rideArray, rideArray[0]);
    };

    const handleShowRideTrackingReplayModal = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        rideTrackingReplay.current.showModal(data.rideId, data.fmVehicleId, data.startTime, data.endTime, data.trackingSourceId);
    };

    const handleVoidReservationModal = (e, data) => {
        e.preventDefault();
        voidReservationModal.current.showModal("Void Reservation", data.rideId, "Dispatch");
    };

    const handleNoShowReservationModal = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        noShowReservationModal.current.showModal("No-Show Reservation", data.rideId, data.reservationId, data.vehicleNo, data.driverId);
    };

    const handleSplitReservationModal = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        splitReservationModal.current.showModal("Split Reservation", data.rideId, data.reservationId, data.noOfAdults, data.vehicleTypeDescription, data.tempPickupDateTime, data.puStreet, data.noOfCharter, true);
    };

    const handleActualTimeModal = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        actualTimeModal.current.showModal("Dispatch", data.rideId, data.airlineCode);
    };

    const handleChangeRideDateTime = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        changeDateTimeReservationModal.current.showModal("Dispatch", data.rideId);
    };

    const handleVehicleHistoryModal = async (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        if (data.vehicleId > 0) {
            vehicleHistoryModal.current.showModal(data.vehicleNo);
        } else {
            await Swal.fire({
                showCloseButton: true,
                title: 'Vehicle not assigned',
                html: 'Vehicle not assigned to ride ' + data.rideId,
                icon: 'question',
                confirmButtonText: 'OK'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    handleRefresh(true);
                    refreshRow();
                }
            });
        }
    };

    const handleShowFlightStatusModal = async (e, data) => {
        try {
            e.preventDefault();
            clearInterval(stopAutoRefresh);
            clearInterval(stopAutoRefreshHandle);
            viewUpdateFlightStatusComponent.current.showModal(data.rideId, data.tempPickupDateTime);
        } catch { /* silent */ }
    };

    const sendCrewAirlineMessageControl = (e, data) => {
        try {
            e.preventDefault();
            clearInterval(stopAutoRefresh);
            clearInterval(stopAutoRefreshHandle);
            SendAirlineCrewMessageComponentModel.current.showAirlineCrewMessageModal(data);
        } catch { /* silent */ }
    };

    const locateVehicle = (e, data) => {
        e.preventDefault();
        clearInterval(stopAutoRefresh);
        clearInterval(stopAutoRefreshHandle);
        locateVehicleModal.current.showModal(data.vehicleNo, data.rideId);
    };

    const handleDetailsRowClose = () => { /* intentionally empty */ };

    const handleEditReservationModel = (e, data) => {
        e.preventDefault();
        editViewRide(data);
    };

    // â”€â”€â”€ Confirmation helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const isConfirm = async (title, confirmationMessage, confirmButtonText) => {
        let isResult = false;
        await Swal.fire({
            title: '<small><b>' + title + '</b></small>',
            html: confirmationMessage,
            icon: 'question',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: confirmButtonText
        }).then(async (result) => {
            if (result.isConfirmed) isResult = true;
        });
        return isResult;
    };

    const onfailure = (title, resultMessage) => {
        Swal.fire({
            allowOutsideClick: false,
            showCloseButton: true,
            icon: 'error',
            title: (!title || title.trim() === '') ? 'Oops...' : title,
            text: (!resultMessage || resultMessage.trim() === '') ? 'Something went wrong!' : resultMessage.trim(),
        });
    };

    // â”€â”€â”€ Action handlers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleResetMeetAndGreeterNameModal = async (e, data) => {
        e.preventDefault();
        let isResult = false;
        await Swal.fire({
            title: 'Confirmation...!',
            html: 'Are you sure to reset the greeter name?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
                isResult = true;
            } else {
                refreshRow();
                setDisplayFlags(prev => ({ ...prev, isSubmited: false }));
            }
        });

        if (isResult) {
            const newObject = {
                RideId: dispatchRideId,
                MGPayTo: 0,
                MeetGreetId: 0,
                MeetGreetName: '',
                MeetGreetAmount: 0,
                IsSetMeetGreet: false,
                DispatcherId: parseInt(sessionStorage.getItem("session_userId")),
            };
            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('meet-greeter-api/SaveUpdate', requestParams);
            const dataResult = await response.json();
            Swal.fire({
                icon: dataResult.isSuccess ? 'success' : 'error',
                title: dataResult.isSuccess ? 'Success' : 'Oops...',
                text: dataResult.resultMessage,
            }).then((result) => {
                if (dataResult.isSuccess) {
                    if (result.isConfirmed) {
                        refreshRow();
                        setDisplayFlags(prev => ({ ...prev, isSubmited: false }));
                    }
                } else {
                    setDisplayFlags(prev => ({ ...prev, isSubmited: false }));
                }
            });
        }
    };

    const handleStatusSubmit = async (e) => {
        e.preventDefault();
        if (handleJobAssignValidation()) {
            setLoading(prev => ({ ...prev, isStatusSubmited: true }));
            const rideStatusRequest = {
                TripStatusId: parseInt(formValues.dispatchStatusId),
                LogTypeId: parseInt(LogType.Reservation),
            };
            const requestParams = getRequestParams('PUT', rideStatusRequest);
            const response = await fetch('/ride-api/' + dispatchRideId + '/status', requestParams);
            const data = await response.json();
            Swal.fire({
                icon: data.isSuccess ? 'success' : 'error',
                title: data.isSuccess ? 'Job Assigned' : 'Oops...',
                text: data.resultMessage,
            }).then((result) => {
                if (data.isSuccess) {
                    if (result.isConfirmed) {
                        setLoading(prev => ({ ...prev, isStatusSubmited: false }));
                        refreshRow();
                    }
                } else {
                    setLoading(prev => ({ ...prev, isStatusSubmited: false }));
                }
            });
        }
    };

    const handleJobAssign = async (e) => {
        e.preventDefault();
        const jobrides = [dispatchRideId];
        if (handleJobAssignValidation()) {
            setLoading(prev => ({ ...prev, isVehicleAssignedSubmited: true }));
            if (formValues.dispatchVehicleId > 0 || formValues.dispatchDriverId > 0) {
                const assignJobRequest = {
                    Rides: jobrides,
                    VehicleId: formValues.dispatchVehicleId,
                    DriverId: formValues.dispatchDriverId,
                    IsAssignRide: true,
                    DriverWorkingHours: parseInt(formValues.driverWorkingHoursValue),
                };
                const requestParams = getRequestParams('POST', assignJobRequest);
                const response = await fetch('/dispatch-api/assign-job', requestParams);
                const data = await response.json();
                Swal.fire({
                    icon: data.isSuccess ? 'success' : 'error',
                    title: data.isSuccess ? 'Job Assigned' : 'Oops...',
                    text: data.resultMessage,
                }).then((result) => {
                    if (data.isSuccess) {
                        if (result.isConfirmed) {
                            setLoading(prev => ({ ...prev, isVehicleAssignedSubmited: false }));
                            refreshRow();
                        }
                    } else {
                        setLoading(prev => ({ ...prev, isVehicleAssignedSubmited: false }));
                    }
                });
            } else {
                const preAssignRequest = {
                    Rides: jobrides,
                    VehicleId: formValues.dispatchVehicleId,
                    DriverId: formValues.dispatchDriverId,
                    IsAssignRide: true,
                    DriverWorkingHours: parseInt(formValues.driverWorkingHoursValue),
                };
                const requestParams = getRequestParams('POST', preAssignRequest);
                const response = await fetch('/dispatch-api/pre-assign-unassign-ride', requestParams);
                const data = await response.json();
                Swal.fire({
                    icon: data.isSuccess ? 'success' : 'error',
                    title: data.isSuccess ? 'Job Assigned' : 'Oops...',
                    text: data.resultMessage,
                }).then((result) => {
                    if (data.isSuccess) {
                        if (result.isConfirmed) {
                            setLoading(prev => ({ ...prev, isVehicleAssignedSubmited: false }));
                            refreshRow();
                        }
                    } else {
                        setLoading(prev => ({ ...prev, isVehicleAssignedSubmited: false }));
                    }
                });
            }
        }
    };

    const handleJobUnAssign = async (e) => {
        e.preventDefault();
        const jobRides = [];
        const preUnAssignRides = [];
        setLoading(prev => ({ ...prev, isVehicleUnAssignedSubmited: true }));
        try {
            switch (parseInt(singleRideSource.tripStatusId)) {
                case parseInt(TripStatus.PENDING):
                case parseInt(TripStatus.DRIVERREJECTED):
                case parseInt(TripStatus.VEHICLEUNASSIGNED):
                    preUnAssignRides.push(dispatchRideId);
                    break;
                case parseInt(TripStatus.ONLOCATION):
                case parseInt(TripStatus.VEHICLEASSIGNED):
                case parseInt(TripStatus.DRIVERACCEPTED):
                    jobRides.push(dispatchRideId);
                    break;
                default:
                    break;
            }
            const unassignJobRequest = {
                DispatcherId: 0,
                JobRides: jobRides,
                PreUnAssignRides: preUnAssignRides,
            };
            const requestParams = getRequestParams('POST', unassignJobRequest);
            const response = await fetch('/dispatch-api/unassign-jobtrip/', requestParams);
            const data = await response.json();
            Swal.fire({
                icon: data.isSuccess ? 'success' : 'error',
                title: data.isSuccess ? 'Job Unassigned' : 'Oops...',
                text: data.isSuccess ? "Job unassigned successful" : data.resultMessage,
            }).then((result) => {
                if (data.isSuccess) {
                    if (result.isConfirmed) {
                        setLoading(prev => ({ ...prev, isVehicleUnAssignedSubmited: false }));
                        refreshRow();
                    }
                } else {
                    setLoading(prev => ({ ...prev, isVehicleUnAssignedSubmited: false }));
                }
            });
        } catch { /* silent */ }
    };

    const handleJobSaveComplete = async (e) => {
        e.preventDefault();
        let isResult = false;
        await Swal.fire({
            title: 'Confirmation...!',
            html: 'Are you sure you want to complete the ride?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
                isResult = true;
            } else {
                setDisplayFlags(prev => ({ ...prev, isSubmited: false }));
            }
        });

        const rideDetails = singleRideSource;
        if (isResult) {
            try {
                if (rideDetails.tripStatusId === parseInt(TripStatus.PENDING) ||
                    rideDetails.tripStatusId === parseInt(TripStatus.VEHICLEUNASSIGNED) ||
                    rideDetails.tripStatusId === parseInt(TripStatus.DRIVERREJECTED)) {
                    const completeJobWebRequest = {
                        Stops: 0,
                        WaitTime: 0,
                        NoShowReason: "",
                        MachineIP: "",
                        VehicleId: formValues.dispatchVehicleId,
                        DriverId: formValues.dispatchDriverId,
                    };
                    const requestParams = getRequestParams('POST', completeJobWebRequest);
                    const response = await fetch('/dispatch-api/' + parseInt(rideDetails.rideId) + '/complete-job', requestParams);
                    const data = await response.json();

                    if (data.isSuccess && rideDetails.airlineCode === "QP") {
                        const requestRateParams = getRequestParams('GET');
                        await fetch('/manage-rides-api/rate-calculate/' + rideDetails.rideId, requestRateParams);
                    }

                    Swal.fire({
                        icon: data.isSuccess ? 'success' : 'error',
                        title: data.isSuccess ? 'Complete Reservation' : 'Oops...',
                        text: data.resultMessage,
                    }).then((result) => {
                        if (data.isSuccess) {
                            if (result.isConfirmed) {
                                setLoading(prev => ({ ...prev, isSaveCompleteSubmited: false }));
                                refreshRow();
                            }
                        } else {
                            setLoading(prev => ({ ...prev, isSaveCompleteSubmited: false }));
                        }
                    });
                } else {
                    clearInterval(stopAutoRefresh);
                    clearInterval(stopAutoRefreshHandle);
                    completeReservationModal.current.showModal("Complete Reservation", rideDetails.rideId, rideDetails.driverId, rideDetails.vehicleNo, "Dispatch", rideDetails.airlineCode);
                }
            } catch (ex) {
                throw ex;
            }
        }
    };

    const handleRecallReservation = async (e) => {
        e.preventDefault();
        setLoading(prev => ({ ...prev, isRecallSubmited: true }));
        const rideStatusRequest = {
            TripStatusId: parseInt(TripStatus.PENDING),
            LogTypeId: parseInt(LogType.Reservation),
        };
        const requestParams = getRequestParams('PUT', rideStatusRequest);
        const response = await fetch('/ride-api/' + dispatchRideId + '/status', requestParams);
        const data = await response.json();
        Swal.fire({
            icon: data.isSuccess ? 'success' : 'error',
            title: data.isSuccess ? 'Recall Reservation' : 'Oops...',
            text: data.resultMessage,
        }).then((result) => {
            if (data.isSuccess) {
                if (result.isConfirmed) {
                    setLoading(prev => ({ ...prev, isRecallSubmited: false }));
                    refreshRow();
                }
            } else {
                setLoading(prev => ({ ...prev, isRecallSubmited: false }));
            }
        });
    };

    const UpdateDriverMobileNo = async (e) => {
        e.preventDefault();
        const errs = { ...errors, driverMobileNumber: "", dispatchDriverId: "" };

        if (!formValues.driverMobileNumber || formValues.driverMobileNumber.trim() === "") {
            setErrors({ ...errs, driverMobileNumber: "Please enter mobile." });
            return;
        }
        if (formValues.driverMobileNumber.trim().replace(/[() -]/g, '').length !== 10) {
            setErrors({ ...errs, driverMobileNumber: "Invalid mobile number." });
            return;
        }
        if (formValues.dispatchDriverId === 0) {
            setErrors({ ...errs, driverMobileNumber: "Please select driver." });
            return;
        }

        const requestParams = getRequestParams('GET');
        const response = await fetch('/dispatch-api/' + formValues.dispatchDriverId + '/' + formValues.driverMobileNumber, requestParams);
        const data = await response.json();
        Swal.fire({
            icon: data.isSuccess ? 'success' : 'error',
            title: data.isSuccess ? 'success' : 'Oops...',
            text: data.resultMessage,
        }).then((result) => {
            if (data.isSuccess && result.isConfirmed) refreshRow();
        });
    };

    const handleUndoSplitReservationModal = async (e, data) => {
        e.preventDefault();
        try {
            const confirmed = await isConfirm('Confirmation', '<small>Are you sure want to undo split?</small>', 'Yes, Undo Split!');
            if (!confirmed) return;
            clearInterval(stopAutoRefresh);
            clearInterval(stopAutoRefreshHandle);
            setDisplayFlags(prev => ({ ...prev, isSubmited: true }));
            const request = { RideId: Number(data.rideId), ReservationId: Number(data.reservationId) };
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('ride-api/undo-split-ride/', requestParams);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.isSuccess) {
                    await Swal.fire({
                        allowOutsideClick: false,
                        icon: 'success',
                        title: 'success',
                        text: (!responseData.resultMessage || responseData.resultMessage.trim() === '')
                            ? 'Ride# [' + responseData.rideId + '] splitted is cancelled ride(s) successfully!'
                            : responseData.resultMessage.trim(),
                    }).then(async (result) => {
                        if (result.isConfirmed) refreshRow();
                    });
                } else {
                    onfailure('Failed to split ride.', responseData.resultMessage);
                }
            } else {
                onfailure();
            }
        } catch { onfailure(); }
        setDisplayFlags(prev => ({ ...prev, isSubmited: false }));
    };

    // â”€â”€â”€ Action buttons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    // [Item 3] Single method replacing two ~250-line duplicate render blocks
    // [Item 9] activityTypeId / customerTypeId derived from prop â€” not state copies
    const renderActionButtons = () => {
        const src = singleRideSource;
        const isLite = session_isShuttleDispatchLite;
        const activityTypeId = singleRideSource?.activityTypeId ?? 0;
        const customerTypeId = singleRideSource?.customerTypeId ?? 0;

        return (
            <>
                {displayFlags.isManualDispatchDisplay && <><button type="button" id="btnSave" className="btn btn-success btn-sm" onClick={handleStatusSubmit} disabled={displayFlags.isSaveDisabled}>
                    {loading.isStatusSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!loading.isStatusSubmited && <span><i className="fas fa-save"></i> Manual Dispatch</span>}
                </button>&nbsp;</>}
                {displayFlags.isUnAssigned && <><button type="button" id="btnSaveUnAssign" className="btn btn-success btn-sm" onClick={handleJobUnAssign}>
                    {loading.isVehicleUnAssignedSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!loading.isVehicleUnAssignedSubmited && <span><i className="fas fa-history"></i> Unassign</span>}
                </button>&nbsp;</>}
                {!displayFlags.isUnAssigned && <><button type="button" id="btnSaveAssign" className="btn btn-success btn-sm" onClick={handleJobAssign} disabled={displayFlags.isSaveAssignDisabled}>
                    {loading.isVehicleAssignedSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!loading.isVehicleAssignedSubmited && <span><i className="fas fa-history"></i> Save & Assign</span>}
                </button>&nbsp;</>}
                {displayFlags.isSaveCompleteDisplay && <><button type="button" id="btnSaveComplete" className="btn btn-success btn-sm" onClick={handleJobSaveComplete} disabled={false}>
                    {loading.isSaveCompleteSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!loading.isSaveCompleteSubmited && <span><i className="fas fa-double-check"></i> Save & Complete</span>}
                </button>&nbsp;</>}
                {displayFlags.isRideCompleteDisplay && <><button type="button" id="btnRideComplete" className="btn btn-success btn-sm" onClick={handleJobSaveComplete} disabled={false}>
                    {loading.isSaveCompleteSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!loading.isSaveCompleteSubmited && <span><i className="fas fa-double-check"></i> Ride Complete</span>}
                </button>&nbsp;</>}
                {!isLite && displayFlags.isSaveCompleteDisplay && <><button type="button" className="btn btn-custom-gray btn-sm" onClick={(e) => handleChangeRideDateTime(e, src)}><i className="fas fa-clock"></i> Change Ride Datetime</button>&nbsp;</>}
                {displayFlags.isCloseDispatchDisplay && <><button type="button" className="btn btn-custom-gray btn-sm" onClick={handleDetailsRowClose}><i className="fas fa-times"></i> Close</button>&nbsp;</>}
                {!isLite && <><button type="button" className="btn btn-custom-gray btn-sm" tag={Link} onClick={(e) => handleEditReservationModel(e, src)}><i className="fas fa-eye"></i> Edit/View</button>&nbsp;</>}
                {(customerTypeId === 5 || customerTypeId === 17) && <><button type="button" className="btn btn-custom-gray btn-sm" tag={Link} onClick={(e) => handlePassengersModal(e, src)}><i className="fas fa-eye"></i> View/Add Passengers</button>&nbsp;</>}
                {displayFlags.isVoidShow && <><button type="button" className="btn btn-custom-gray btn-sm" onClick={(e) => handleVoidReservationModal(e, src)}><i className="fas fa-times"></i> Void</button>&nbsp;</>}
                {displayFlags.isRecallShow && <><button type="button" className="btn btn-custom-gray btn-sm" onClick={handleRecallReservation}>
                    {loading.isRecallSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!loading.isRecallSubmited && <span><i className="fas fa-times"></i> Recall</span>}
                </button>&nbsp;</>}
                <button type="button" className="btn btn-custom-gray btn-sm" onClick={(e) => handleReservationHistoryModal(e, src)}>
                    {loading.isHistorySubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!loading.isHistorySubmited && <span><i className="fas fa-history"></i> Ride History</span>}
                </button>&nbsp;
                {displayFlags.isTripStatusDisplay && <><button type="button" id="btnLocate" className="btn btn-custom-gray btn-sm" onClick={(e) => locateVehicle(e, src)} title="Locate"><i className="fas fa-map-marker"></i> Locate</button>&nbsp;</>}
                {displayFlags.isShowVehicleHistory && <><button type="button" id="btnVehicleHistory" className="btn btn-custom-gray btn-sm" onClick={(e) => handleVehicleHistoryModal(e, src)} title="Vehicle History"><i className="fas fa-history"></i> Vehicle History</button>&nbsp;</>}
                {!isLite && displayFlags.isDocumentsAttachment && <><button type="button" id="btnRideDocuments" className="btn btn-custom-gray btn-sm" onClick={(e) => handleRideDocumentsModal(e, src)} title="Upload/View Attachment"><i className="fas fa-upload"></i> Attachments</button>&nbsp;</>}
                {!isLite && displayFlags.isSplitRideDisplay && <><button type="button" id="btnSplitRide" className="btn btn-custom-gray btn-sm" onClick={(e) => handleSplitReservationModal(e, src)} title="Split Ride"><i className="fas fa-unlink"></i> Split Ride</button>&nbsp;</>}
                {!isLite && displayFlags.isActualTime && <><button type="button" id="btnActualRide" className="btn btn-custom-gray btn-sm" onClick={(e) => handleActualTimeModal(e, src)} title="Actual Time"><i className="fas fa-clock"></i> Actual Time</button>&nbsp;</>}
                {!isLite && displayFlags.isUndoSplitRideDisplay && <button type="button" id="btnUndoSplit" className="btn btn-custom-gray btn-sm" onClick={(e) => handleUndoSplitReservationModal(e, src)}>
                    {displayFlags.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!displayFlags.isSubmited && <span title="Undo Split"><i className="fas fa-undo"></i> Undo Split</span>}
                </button>}
                {displayFlags.isNoshowDisplay && <><button type="button" id="btnNoShow" className="btn btn-custom-gray btn-sm" onClick={(e) => handleNoShowReservationModal(e, src)} title="No Show"><i className="fas fa-eye-slash"></i> No Show</button>&nbsp;</>}
                {!isLite && parseInt(displayFlags.iMeetGreetDisplay) === 1 && <><button type="button" id="btnSetMeetAndGreeterName" className="btn btn-custom-gray btn-sm" onClick={(e) => handleMeetAndGreeterNameModal(e, src)} title="Set Meet and Greeter Name"><i className="fas fa-user-cog"></i> Set Meet and Greeter Name</button>&nbsp;</>}
                {!isLite && parseInt(displayFlags.iMeetGreetDisplay) === 2 && <><button type="button" id="btnSetMeetAndGreeterName" className="btn btn-custom-gray btn-sm" onClick={(e) => handleResetMeetAndGreeterNameModal(e, src)} title="Reset Meet and Greeter Name"><i className="fas fa-user-cog"></i> Reset Meet and Greeter Name</button>&nbsp;</>}
                {formValues.dispatchStatusId === TripStatus.COMPLETED && <><button type="button" id="btnRideTrackingReplay" className="btn btn-custom-gray btn-sm" onClick={(e) => handleShowRideTrackingReplayModal(e, src)} title="Replay"><i className="fas fa-user-cog"></i> Replay</button>&nbsp;</>}
                {!isLite && displayFlags.isShowFlightStatus && activityTypeId !== 2 &&
                    <button type="button" id="btnShowFlightStatus" className="btn btn-custom-gray btn-sm" onClick={(e) => handleShowFlightStatusModal(e, src)} title="Click on flight status and get current flight status">
                        <i className="fas fa-plane"></i> Flight Status
                    </button>
                }
                &nbsp;
                {/* [Item 6] && not || â€” hides button when ride is in terminal status */}
                {!isLite && activityTypeId !== 2 &&
                    formValues.dispatchStatusId !== TripStatus.COMPLETED &&
                    formValues.dispatchStatusId !== TripStatus.AUTOCANCELLED &&
                    formValues.dispatchStatusId !== TripStatus.CANCELLED &&
                    <button type="button" id="routeCrewAirlineMessage" className="btn btn-custom-gray btn-sm" onClick={(e) => sendCrewAirlineMessageControl(e, src)} title="Send airline crew message">
                        <i className="fas fa-sms"></i> Send Airline Crew Message
                    </button>
                }
            </>
        );
    };

    // â”€â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    return (
        <form method="post">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="row form-horizontal form-group">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 displayNone">
                            <div className="row">
                                <label htmlFor="" className="col-lg-2 col-md-2 col-sm-2 col-xs-2 col-form-label">Status</label>
                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <SelectBox
                                        dataSource={serviceData.serviceStatusList?.length > 0 ? serviceData.serviceStatusList : []}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Select status"
                                        name="dispatchStatusId"
                                        defaultValue={0}
                                        value={formValues.dispatchStatusId}
                                        displayExpr='name'
                                        valueExpr='id'
                                        onSelectionChanged={handleDispatchStatusChange}
                                        showClearButton={true}
                                        disabled={false}
                                        searchEnabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2" style={{ paddingRight: '2px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'nowrap' }}>
                                <label htmlFor="" className="col-form-label" style={{ whiteSpace: 'nowrap', margin: 0, fontSize: '0.8rem' }}>Vehicles</label>
                                <SelectBox
                                    dataSource={serviceData.serviceVehicles?.length > 0 ? serviceData.serviceVehicles : []}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select vehicle"
                                    name="dispatchVehicleId"
                                    defaultValue={0}
                                    value={formValues.dispatchVehicleId}
                                    displayExpr='name'
                                    valueExpr='id'
                                    onSelectionChanged={handleDispatchVehicleChange}
                                    showClearButton={true}
                                    disabled={false}
                                    searchEnabled={true}
                                    width={300}
                                    itemRender={vehicleItemRender}
                                    fieldRender={vehicleFieldRender}
                                />
                            </div>
                            {errors.dispatchVehicleId.length > 0 && <span className='error invalid-feedback'>{errors.dispatchVehicleId}</span>}
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2" style={{ paddingLeft: '2px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'nowrap' }}>
                                <label htmlFor="" className="col-form-label" style={{ whiteSpace: 'nowrap', margin: 0, fontSize: '0.8rem' }}>Drivers</label>
                                <SelectBox
                                    dataSource={serviceData.serviceDrivers?.length > 0 ? serviceData.serviceDrivers : []}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select driver"
                                    name="dispatchDriverId"
                                    defaultValue={0}
                                    value={formValues.dispatchDriverId}
                                    displayExpr='name'
                                    valueExpr='id'
                                    onSelectionChanged={handleDispatchDriverChange}
                                    showClearButton={true}
                                    disabled={false}
                                    searchEnabled={true}
                                    width={300}
                                    itemRender={driverItemRender}
                                    fieldRender={driverFieldRender}
                                />
                            </div>
                            {errors.dispatchDriverId.length > 0 && <span className='error invalid-feedback'>{errors.dispatchDriverId}</span>}
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2" style={{ display: singleRideSource.driverId === 0 ? "none" : "block" }}>
                            <div className="row">
                                <label htmlFor="" className="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-form-label">Mobile</label>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                    <NumberFormat className="form-control form-control-sm" name="driverMobileNumber" placeholder="(000) 000-0000" title="Mobile Number" value={formValues.driverMobileNumber} onChange={handleInputChange} format="(###) ###-####" />
                                    {errors.driverMobileNumber.length > 0 && <span className='error invalid-feedback'>{errors.driverMobileNumber}</span>}
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <button type="button" className="btn btn-success btn-sm" onClick={UpdateDriverMobileNo}>Update</button>
                                </div>
                            </div>
                        </div>
                        <div className={allowToAddDriverWorkingHours === "true" ? "col-lg-2 col-md-2 col-sm-2 col-xs-2 displayBlock" : "col-lg-2 col-md-2 col-sm-2 col-xs-2 displayNone"}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'nowrap' }}>
                                <label htmlFor="" className="col-form-label" style={{ whiteSpace: 'nowrap', margin: 0, fontSize: '0.8rem' }}>Working Hours</label>
                                <SelectBox
                                    dataSource={driverWorkingHoursobject}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select"
                                    name="driverWorkingHoursId"
                                    defaultValue={0}
                                    value={formValues.driverWorkingHoursId}
                                    displayExpr='name'
                                    valueExpr='id'
                                    onSelectionChanged={handleDriverWorkingHourChange}
                                    showClearButton={true}
                                    disabled={false}
                                    searchEnabled={false}
                                    width={110}
                                    visible={allowToAddDriverWorkingHours === "true"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row form-horizontal form-group">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label>&nbsp;</label>
                    {renderActionButtons()}
                </div>
            </div>
            <ViewReservationComponent ref={viewReservationModal} />
            <ReservationHistoryComponent ref={reservationHistoryModal} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <AddPassengerComponent ref={addPassengerModal} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <VoidReservationComponent ref={voidReservationModal} refreshDataSource={refreshDataSource} />
            <NoShowReservationComponent ref={noShowReservationModal} refreshDataSource={refreshDataSource} singleRideSource={singleRideSource} handleRefresh={handleRefresh} />
            <SplitReservationComponent ref={splitReservationModal} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <VehicleHistoryComponent ref={vehicleHistoryModal} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <MeetAndGreeterComponent ref={meetAndGreeterDataModel} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <LocateVehicleComponent ref={locateVehicleModal} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <DocumentsComponent ref={reservationDocumentsModal} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <ReservationActualTimeComponent ref={actualTimeModal} />
            <RideTrackingReplay ref={rideTrackingReplay} />
            <CompleteReservationComponent ref={completeReservationModal} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <ReservationDateTimeComponent ref={changeDateTimeReservationModal} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <ViewUpdateFlightStatusComponent ref={viewUpdateFlightStatusComponent} refreshDataSource={refreshDataSource} handleRefresh={handleRefresh} />
            <SendAirlineCrewMessageComponent ref={SendAirlineCrewMessageComponentModel} />
        </form>
    );
}
 
